import { Component } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { ViewController, NavParams } from 'ionic-angular';

import { GlobalsSingleton } from '../../app/core/GlobalsSingleton';


@Component({
  templateUrl: 'NotfallrufnummernPopup.html'
})
export class NotfallrufnummernPopup {

  dataToDisplay : SafeHtml = ""

  constructor(public viewCtrl: ViewController, public navParams: NavParams, public globals: GlobalsSingleton) {
	this.dataToDisplay = this.navParams.get('data');
  }


  close(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/popups/NotfallrufnummernPopup.ts